import { Clippy, addToGlobalThisRet } from "@plugins";

function initEventModalFilesAttacher() {
    const attacher = document.querySelector(".js-file-input-attacher-init");
    const logoFormats = document.querySelector("meta[name='valid_logo-ext']").content;
    const docFormats = document.querySelector("meta[name='valid_file-ext']").content;

    if (attacher) {
        if (logoFormats && docFormats) {
            const isLogo = attacher.classList.contains("add-logo__attach");

            if (!attacher.classList.contains("attacher-initiallized")) {
                new Clippy(".js-file-input-attacher-init", {
                    multi: true,
                    accept: isLogo ? logoFormats.split(", ") : docFormats.split(", "),
                    input: {
                        el: ".js-file-input",
                    },
                    filesList: {
                        classes: ["file-input__list", "documents__list"],
                        items: {
                            template(file) {
                                const icon = file.extension === "svg" ? "image" : file.extension;
                                return `
                                    <li class="document file-input__item">
                                        <svg class="document__icon" width="40px" height="53px">
                                            <use xlink:href="images/svg-icons/document-icons/icons.svg#${icon}"></use>
                                        </svg>
                                        <div class="document__content">
                                            <span class="document__content-name">${file.name}.${file.extension}</span>
                                            <div class="document__controls">
                                                <button class="document__controls-btn" data-clippy-remover>Удалить</button>
                                            </div>
                                        </div>
                                    </li>
                                `;
                            },
                        },
                        insert: {
                            functionType: "append",
                        },
                    },
                });

                attacher.classList.add("attacher-initiallized");
            }
        }
    }
}

addToGlobalThisRet(initEventModalFilesAttacher, "initEventModalFilesAttacher");
